import React, { useEffect, useRef, useState } from "react";
import { avanzoApi } from "@/lib/avanzoApi";
import BuddyReflectionCard from "./BuddyReflectionCard";

/**
 * PostEvalBuddy — arranca UNA (y sólo una) reflexión de cierre tras
 * completar una evaluación (Progress Check, Simulacro 1, Simulacro Final).
 *
 * Usa `useRef` como guard idempotente para evitar la doble ejecución
 * del useEffect bajo React 18 StrictMode — el bug detectado por el
 * testing agent iteración 22 mostraba 2 documentos insertados en Mongo
 * por cada mount porque el guard estaba con `useState` (closure stale).
 *
 * Props:
 *   source: "progress_check" | "simulation_1" | "final_simulation"
 *   reflectionType: "POST_PC" | "POST_SIM1" | "POST_FINAL"
 */
export default function PostEvalBuddy({ source, reflectionType }) {
  const [reflection, setReflection] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const startedRef = useRef(false);

  useEffect(() => {
    // Guard idempotente resistente a StrictMode double-invoke.
    if (startedRef.current) return;
    startedRef.current = true;

    let cancelled = false;
    (async () => {
      try {
        const r = await avanzoApi.buddyStart({
          source,
          reflection_type: reflectionType,
          trigger_reason: `post_${source}`,
        });
        if (!cancelled && r?.data?.reflection_id) {
          setReflection(r.data);
        }
      } catch (_) { /* silencioso: Buddy nunca bloquea el flujo */ }
    })();
    return () => { cancelled = true; };
  }, [source, reflectionType]);

  if (dismissed || !reflection) return null;
  return (
    <BuddyReflectionCard
      reflection={reflection}
      onClose={() => setDismissed(true)}
      variant="post"
    />
  );
}
